<template>
  <div>
    <button class="again_btn" :class="{ disabled }">
      {{ title }}
    </button>
  </div>
</template>

<script>
export default {
  name: "SendAgainButton",
  props: {
    disabled: Boolean,
    title: {
      type: String,
      default: ""
    }
  }
}
</script>
